import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import dayjs from "dayjs";
import Loader from "../../../core/common/selfLoder";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import weekOfYear from "dayjs/plugin/weekOfYear";

// class="fc-daygrid-day-frame fc-scrollgrid-sync-inner"

dayjs.extend(isSameOrBefore);
dayjs.extend(weekOfYear);

interface Holiday {
  holiday: string;
  holiday_date: string;
  holiday_category: string;
  location: string;
}

interface HolidaysMainResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: Holiday[];
}

const LeaveClender = () => {
  const [holidaySet, setHolidaySet] = useState<Set<string>>(new Set());
  const [weekendSet, setWeekendSet] = useState<Set<string>>(new Set());
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };
  const [rhHolidaySet, setRhHolidaySet] = useState<Set<string>>(new Set());

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const {
    data: holidayResponse,
    loading: holidayLoading,
    error: holidayError,
  } = useApi<HolidaysMainResponse>("/api/holiday-list", {
    method: "POST",
    autoCall: true,
    payload: {
      category: "",
    },
  });

  const {
    data: weekendResponse,
    loading: weekendLoading,
    error: weekendError,
  } = useApi("/api/weekend-rule", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: leave_details,
    loading: leave_details_loading,
    error: leave_Details_error,
  } = useApi("/api/view-leave-status", {
    method: "POST",
    autoCall: true,
    payload: {
      financial_year: finance_year,
    },
  });
  console.log(leave_details);
  // State to hold events formatted for FullCalendar
  const [events, setEvents] = useState<any>([]);

  type LeaveStatus = "APPROVED" | "PENDING" | "REJECTED";

  const statusColors: Record<
    LeaveStatus,
    { backgroundColor: string; borderColor: string; textColor?: string }
  > = {
    APPROVED: {
      backgroundColor: "green",
      borderColor: "green",
      textColor: "#fff",
    }, // Green for approved
    PENDING: {
      backgroundColor: "yellow",
      borderColor: "#ccc",
      textColor: "#000",
    }, // Yellow for pending
    REJECTED: {
      backgroundColor: "red",
      borderColor: "red",
      textColor: "#fff",
    }, // Red for rejected/disapproved
  };
  useEffect(() => {
    if (holidayResponse?.data) {
      const holSet = new Set(holidayResponse.data.map((h) => h.holiday_date));

      const rhHolidaySet = new Set(
        holidayResponse.data
          .filter((h) => h.holiday_category === "RH")
          .map((h) => h.holiday_date)
      );

      // ✅ Holiday Events with Text Color (No Background)
      const holidayEvents = holidayResponse.data.map((h) => {
        let textColor = "#dc3545"; // Default: GH (red)

        if (h.holiday_category === "RH") {
          textColor = "#007bff"; // RH - Blue
        } else if (h.holiday_category === "MH") {
          textColor = "#dc3545"; // MH - Purple
        }

        return {
          id: `hol-${h.holiday_date}`,
          title: h.holiday,
          start: h.holiday_date,
          allDay: true,
          backgroundColor: "transparent", // No background color
          textColor: textColor,
          extendedProps: {
            category: h.holiday_category,
            isHoliday: true,
          },
        };
      });

      // ✅ Weekend Events: All Sundays and Saturdays EXCEPT last Saturday of each month
      const startOfYear = dayjs(`${finance_year.slice(0, 4)}-04-01`);
      const endOfYear = startOfYear.add(1, "year").subtract(1, "day");

      // Find last Saturdays of each month
      let lastSaturdays = new Set<string>();
      let monthCursor = startOfYear.startOf("month");
      while (monthCursor.isBefore(endOfYear)) {
        let lastDayOfMonth = monthCursor.endOf("month");
        while (lastDayOfMonth.day() !== 6) {
          lastDayOfMonth = lastDayOfMonth.subtract(1, "day");
        }
        lastSaturdays.add(lastDayOfMonth.format("YYYY-MM-DD"));
        monthCursor = monthCursor.add(1, "month");
      }

      // Collect all Sundays and Saturdays except last Saturdays
      let weekendDates: string[] = [];
      let current = startOfYear;

      while (current.isSameOrBefore(endOfYear, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        const day = current.day(); // 0 = Sunday, 6 = Saturday

        if (day === 0 || (day === 6 && !lastSaturdays.has(dateStr))) {
          weekendDates.push(dateStr);
        }

        current = current.add(1, "day");
      }

      const weekendEvents = weekendDates.map((date) => ({
        id: `wd-${date}`,
        title: "",
        start: date,
        allDay: true,
      }));

      // Set states
      setHolidaySet(holSet);
      setRhHolidaySet(rhHolidaySet)
      setWeekendSet(new Set(weekendDates));
      setEvents((prev: any) => [...holidayEvents, ...weekendEvents, ...prev]);
    }
  }, [holidayResponse, weekendResponse, finance_year]);


 useEffect(() => {
  if (leave_details?.data) {
    const leaveEvents: any[] = [];

    const filteredLeaves = leave_details.data.filter(
      (item: any) => item.status?.toUpperCase() !== "REJECTED"
    );

    filteredLeaves.forEach((l: any) => {
      const {
        from_date,
        to_date,
        leave_type,
        status,
        leave_application_id,
        application_reason,
        leave_slice_type,
      } = l;

      const startDate = dayjs(from_date);
      const endDate = to_date ? dayjs(to_date) : null;

      const isHalfDay = leave_slice_type?.toLowerCase().includes("half");

      if (isHalfDay) {
        const date = startDate.format("YYYY-MM-DD");

        const isWeekend = weekendSet.has(date);
        // ✅ Allow RH leave
        if (!isWeekend) {
          leaveEvents.push({
            id: `leave-${leave_application_id}-${date}`,
            title: `${leave_type} (${leave_slice_type})`,
            start: date,
            allDay: true,
            ...statusColors[status as LeaveStatus],
            extendedProps: { application_reason, status },
          });
        }
      } else if (endDate) {
        let curr = startDate;

        while (curr.isSameOrBefore(endDate, "day")) {
          const date = curr.format("YYYY-MM-DD");

          const isWeekend = weekendSet.has(date);
          const isMH = holidayResponse?.data.find(h => h.holiday_date === date && h.holiday_category === "MH");

          // ✅ Skip only weekends and MH holidays; allow RH
          if (!isWeekend && !isMH) {
            leaveEvents.push({
              id: `leave-${leave_application_id}-${date}`,
              title: leave_type,
              start: date,
              allDay: true,
              ...statusColors[status as LeaveStatus],
              extendedProps: { application_reason, status },
            });
          }

          curr = curr.add(1, "day");
        }
      }
    });

    setEvents((prev: any) => [
      ...prev.filter((e: any) => !e.id.startsWith("leave-")),
      ...leaveEvents,
    ]);
  }
}, [leave_details, holidaySet, weekendSet, rhHolidaySet]);

  return (
    <>
      <Loader loading={leave_details_loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leave Calender</h2>
              <nav>

                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Leave</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.seflGrid}>Self Leave</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leave Calender
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>
{/* 
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select> */}
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xxl-12 col-xl-12  theiaStickySidebar">
              <div className="stickybar">
                <div className="card border-0">
                  <div className="card-body">
                    <FullCalendar
                      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                      initialView="dayGridMonth"
                      headerToolbar={{ start: "today", center: "title", end: "prev,next" }}
                      height="auto"
                      events={events}
                      dayCellContent={({ date }) => {
                        const formattedDate = dayjs(date).format("YYYY-MM-DD");

                        // Match event by date
                        const matchedEvent = events.find((e: any) => e.start === formattedDate);

                        let dotColor = "";
                        let tooltip = "";

                        if (matchedEvent) {
                          const title = matchedEvent.title || "";
                          const status = matchedEvent.extendedProps?.status;
                          const isHoliday = holidaySet.has(formattedDate);
                          const isWeekend = weekendSet.has(formattedDate);

                          if (isHoliday) {
                            const holidayDetails = holidayResponse?.data.find(h => h.holiday_date === formattedDate);
                            const category = holidayDetails?.holiday_category;
                            dotColor = category === "RH" ? "#007bff" : "#dc3545"; // Blue for RH, Red for GH
                            tooltip = `${holidayDetails?.holiday} (${category})`;
                          } else if (isWeekend) {
                            dotColor = "#17a2b8"; // Blue-ish for weekends
                            tooltip = "Weekend";
                          } else if (status) {
                            switch (status.toUpperCase()) {
                              case "APPROVED":
                                dotColor = "#28a745";
                                tooltip = "Approved Leave";
                                break;
                              case "PENDING":
                                dotColor = "#fd7e14";
                                tooltip = "Pending Leave";
                                break;
                              case "REJECTED":
                                dotColor = "#dc3545";
                                tooltip = "Rejected Leave";
                                break;
                              default:
                                dotColor = "#6c757d";
                                tooltip = status;
                            }
                          }
                        }

                        return (
                          <div style={{ position: "relative", textAlign: "center" }}>
                            <div>{date.getDate()}</div>
                            {dotColor && (
                              <div style={{ display: "flex", justifyContent: "center", marginTop: "5px" }}>
                                <span
                                  title={tooltip}
                                  style={{
                                    width: 10,
                                    height: 10,
                                    backgroundColor: dotColor,
                                    borderRadius: "50%",
                                    display: "inline-block",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        );
                      }}
                    />
                    {/* Legend */}
                    <div className="row mt-2">
                      <div className="col-12">
                        <div className="card p-4 shadow-sm">
                          <h4 className="mb-3">Status Legend</h4>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "35px",
                            }}
                          >
                            {/* Present */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <span
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  backgroundColor: "#28a745", // green
                                  borderRadius: "4px",
                                  display: "inline-block",
                                }}
                              ></span>
                              <span>Approved</span>
                            </div>

                            {/* Absent */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <span
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  backgroundColor: "#dc3545", // red
                                  borderRadius: "4px",
                                  display: "inline-block",
                                }}
                              ></span>
                              <span>Rejected</span>
                            </div>



                            {/* Weekend Off */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <span
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  backgroundColor: "#007bff", // yellow (WO)
                                  borderRadius: "4px",
                                  display: "inline-block",
                                }}
                              ></span>
                              <span>Weekend Off</span>
                            </div>

                            {/* RH Holiday */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <span
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  backgroundColor: "transparent",
                                  border: "2px solid #007bff", // blue border for RH
                                  borderRadius: "4px",
                                  display: "inline-block",
                                }}
                              ></span>
                              <span>Restricted Holiday (RH)</span>
                            </div>

                            {/* MH Holiday */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <span
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  backgroundColor: "#dc3545", // red
                                  borderRadius: "4px",
                                  display: "inline-block",
                                }}
                              ></span>
                              <span>Mandatory Holiday (MH)</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default LeaveClender;
